import { connect } from 'react-redux';
import RolesRow from './RolesRow';
import { userStatusLoading } from '../../../../../store/selectors/user.selector';
import { isModal } from '../../../../../store/selectors/general.selector';
import { sortRolesRequest, updateRoleFlag } from '../../../../../store/actions/user.actions';
import { closeModalRequest } from '../../../../../store/actions/general.actions';

const mapDispatchToProps = { closeModalRequest, sortRolesRequest, updateFlag: updateRoleFlag };

const mapStateToProps = (state) => { 
    const statusLoading = userStatusLoading(state);
    const modalStatus = isModal(state);

    return { statusLoading, modalStatus };
 };

export default connect(mapStateToProps, mapDispatchToProps)(RolesRow);